import { render, staticRenderFns } from "./CustomerEditDot.vue?vue&type=template&id=ea8092fc"
import script from "./CustomerEditDot.vue?vue&type=script&lang=js"
export * from "./CustomerEditDot.vue?vue&type=script&lang=js"
import style0 from "./CustomerEditDot.vue?vue&type=style&index=0&id=ea8092fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports